module.exports = __webpack_public_path__ + "img/question-mark.0a35d794.svg";